<app-fr-card class="desktop-card-shadow-team">
  <div class="team-container">
    <div class="team-heading">Team</div>
    <div class="line"></div>
    <div class="container">
        <div class="team-member-wrapper row">
          <div class="col-md-6" *ngFor="let item of team">
            <div class="team-member">
              <div class="tm-img-container">
                <i *ngIf="!item?.member?.avtar" class="icon-user1"></i>
                <img loading="lazy" [hidden]="!(item?.member?.avtar)" class="tm-img" [attr.data-src]="item?.member?.avtar?.cdn_path" [alt]="item?.member?.full_name" />
              </div>
              <div class="tm-content">
                <div class="tm-name">{{item?.member?.full_name}}</div>
                <div class="tm-title">{{item?.designation}}</div>
                <div class="tm-social">
                  <span *ngFor="let link of item?.member?.sociallinks">
                    <a *ngIf="link.link_1" [href]="link.link_1" target="_blank" rel="noopener noreferrer">
                      <mat-icon class="social-icon"  [ngClass]="getClass(link.entity_link_type)"></mat-icon>
                    </a>
                  </span>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-fb-share-card [sharedCounts]="sharedCounts"></app-fb-share-card> -->
    <!-- <app-reward [rewards]="rewards" [isFundraiserEnded]="isFundraiserEnded"></app-reward> -->
  </div>
</app-fr-card>
